import axiosConfig from "./axiosConfig";

export interface PromoteArtifactResponse {
  artifact: {
    guid: string;
    uploadedAt: number;
    filename: string;
  };
}

const promoteSiteArtifact = async (
  authToken: string,
  siteId: string,
  artifactGuid: string
): Promise<PromoteArtifactResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/artifacts/${artifactGuid}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default promoteSiteArtifact;
